"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var types = ['Array', 'Object', 'String', 'Date', 'RegExp', 'Function', 'Boolean', 'Number', 'Null', 'Undefined'];
exports.default = (function () {
    var typeChecker = {};
    // ex. [object String] => String, [object Date] => Date
    var getType = function (elem) {
        return Object.prototype.toString.call(elem).slice(8, -1);
    };
    types.forEach(function (type) {
        typeChecker["is" + type] = (function (type) { return function (elem) { return getType(elem) === type; }; })(type);
    });
    return typeChecker;
})();
//# sourceMappingURL=typeChecker.js.map